import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home1/pocket-banner.png';
const _withScopeId = n => (_pushScopeId("data-v-6250cb6a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-pocket-banner",
  "aria-labelledby": "pocket-banner-title"
};
const _hoisted_2 = {
  class: "pocket-shell"
};
const _hoisted_3 = {
  class: "pocket-panel"
};
const _hoisted_4 = {
  class: "pocket-copy"
};
const _hoisted_5 = {
  id: "pocket-banner-title"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_7 = ["alt"];
import CusomDownload from '@/components/home/CusomDownload.vue';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'HomePocketBanner',
  setup(__props) {
    const {
      t
    } = useI18n();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", _hoisted_5, [_createTextVNode(_toDisplayString(_unref(t)('homepage.pocket.title')), 1), _hoisted_6, _createTextVNode(_toDisplayString(_unref(t)('homepage.pocket.titleLine2')), 1)]), _createElementVNode("p", null, _toDisplayString(_unref(t)('homepage.pocket.description')), 1), _createVNode(CusomDownload, {
        class: "pocket-download"
      })]), _createElementVNode("img", {
        class: "pocket-art",
        src: _imports_0,
        alt: _unref(t)('homepage.pocket.imageAlt')
      }, null, 8, _hoisted_7)])])]);
    };
  }
};